import React, {Suspense} from 'react';
import PageLayout from "@view/layout/pageLayout/PageLayout";
import SpinnerCustom from "@ui/spinner/SpinnerCustom";
import {TasksTemplateSingleVoyagesLazy} from "@containers/singleVoyage/taskTemplate/TasksTemplateSingleVoyages.lazy";
import {useAppContext} from "@context/appContext/hooks/useAppContext";

const TasksTemplateSingleVoyagesPage = () => {

    return (
        <PageLayout>
            <Suspense
                fallback={<SpinnerCustom/>}
            >
                <TasksTemplateSingleVoyagesLazy/>
            </Suspense>
        </PageLayout>
    );
};

export default TasksTemplateSingleVoyagesPage;
